import axios from 'axios';

export const state = {
  account: [],
  loading: false,
};

export const mutations = {
  setAccount(context, account) {
    context.account = account;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getAccountByUserId(context, userId) {
    return axios.get(
      `${window.BASE_API.BAADER}/data/account/${userId}`,
    ).then(response => response.data).catch(error => Promise.reject(error));
  },
  async getAccountBySnr(context, snr) {
    return axios.get(
      `${window.BASE_API.BAADER}/account/${snr}`,
    ).then(response => response.data).catch(error => Promise.reject(error));
  },
  async updateSetting(context, data) {
    return axios.post(
      `${window.BASE_API.BAADER}/update-account-setting`,
      data,
    ).then(response => response.data).catch(error => Promise.reject(error));
  },
  async downloadDocument(context, documentId) {
    return axios.get(
      `${window.BASE_API.BAADER}/document/${documentId}`,
    ).then(response => response.data).catch(error => Promise.reject(error));
  },
};

const baaderAccountStore = {
  state,
  mutations,
  actions,
};

export default baaderAccountStore;



// WEBPACK FOOTER //
// ./src/store/baader/baaderAccountStore.js